"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyPress = exports.useOutsideClick = exports.useTrapFocus = void 0;
var react_1 = require("react");
var tabbable_1 = require("tabbable");
var useTrapFocus = function (ref) {
    var trapFocus = function (e) {
        var tabbableElements = ref && ref.current ? (0, tabbable_1.tabbable)(ref.current) : [];
        if (tabbableElements.length < 1) {
            return;
        }
        var firstTabbableElement = tabbableElements[0];
        var lastTabbableElement = tabbableElements[tabbableElements.length - 1];
        if (e.key === 'Tab' && e.shiftKey) {
            if (document.activeElement === firstTabbableElement) {
                lastTabbableElement.focus();
                e.preventDefault();
            }
        }
        else if (e.key === 'Tab') {
            if (document.activeElement === lastTabbableElement) {
                firstTabbableElement.focus();
                e.preventDefault();
            }
        }
    };
    (0, react_1.useEffect)(function () {
        var _a;
        var tabbableElements = ref && ref.current ? (0, tabbable_1.tabbable)(ref.current) : [];
        (_a = tabbableElements[0]) === null || _a === void 0 ? void 0 : _a.focus();
        document.addEventListener('keydown', trapFocus);
        return function () {
            document.removeEventListener('keydown', trapFocus);
        };
    }, [ref, trapFocus]);
};
exports.useTrapFocus = useTrapFocus;
var useOutsideClick = function (ref, callback, options) {
    var handleOutsideClick = function (e) {
        var _a;
        if (!(options === null || options === void 0 ? void 0 : options.disable) && !((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            callback();
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleOutsideClick);
        return function () {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [handleOutsideClick]);
};
exports.useOutsideClick = useOutsideClick;
var useKeyPress = function (targetKey, callback, options) {
    var handleKeyPress = function (e) {
        if (!(options === null || options === void 0 ? void 0 : options.disable) && e.key === targetKey) {
            callback();
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', handleKeyPress);
        return function () {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);
};
exports.useKeyPress = useKeyPress;
